import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { id: "ViewPostsView" }
const _hoisted_2 = { class: "docArea" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "info" }

import { onMounted, ref } from "vue";
import message from "@arco-design/web-vue/es/message";
import {
  PostComment,
  PostCommentAddRequest,
  PostCommentControllerService,
  PostCommentQueryRequest,
  PostControllerService,
  PostVO,
} from "../../generated";
import MdViewer from "@/components/MdViewer.vue";
import MdEditor from "@/components/MdEditor.vue";
import CommentCard from "@/components/CommentCard.vue";
import moment from "moment/moment";

interface Props {
  id: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewPostView',
  props: {
    id: { default: () => "" }
  },
  setup(__props: any) {

const post = ref<PostVO>();

const props = __props;
const commentSearchParams = ref({
  postId: props.id as any,
  pageSize: 10,
  current: 1,
  reviewStatus: 1, //已审核通过
} as PostCommentQueryRequest);
const commentList = ref<Array<PostComment>>();

const loadData = async () => {
  const res = await PostControllerService.getPostVoByIdUsingGet(
    props.id as any
  );
  if (res.code === 0) {
    post.value = res.data;
  } else {
    message.error("加载失败！ " + res.message);
  }

  //拿到当前帖子通过审核的题解
  // 校验分页数量
  if (
    !commentSearchParams.value.pageSize ||
    commentSearchParams.value.pageSize <= 0
  ) {
    commentSearchParams.value.pageSize = 5;
  }
  const commentRes =
    await PostCommentControllerService.listPostCommentVoByPageUsingPost(
      commentSearchParams.value
    );
  if (commentRes.code === 0) {
    commentList.value = commentRes.data.records;
  } else {
    message.error("加载失败！ " + commentRes.message);
  }
};
onMounted(() => {
  loadData();
});

const comment = ref({
  content: "# 说点什么...",
} as PostCommentAddRequest);

const onContentChange = (v: string) => {
  comment.value.content = v;
};

const doCommentSubmit = async () => {
  if (props.id !== "" && comment.value.content !== "") {
    const res = await PostCommentControllerService.addPostCommentUsingPost({
      ...comment.value,
      postId: props.id as any,
    });
    if (res.code === 0) {
      message.success("提交成功！");
    } else {
      message.error("提交失败！ " + res.message);
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, { gutter: [24, 24] }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          md: 12,
          xs: 24
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (post.value)
                ? (_openBlock(), _createBlock(_component_a_card, {
                    key: 0,
                    bordered: false,
                    title: post.value.title,
                    style: {"margin-top":"10px","height":"95%","flex":"1"}
                  }, {
                    extra: _withCtx(() => [
                      _createVNode(_component_a_space, { wrap: "" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(post.value.tag, (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_tag, {
                              key: index,
                              color: "green"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, { style: {"align-items":"center"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_avatar, { size: 100 }, {
                                default: _withCtx(() => [
                                  (post.value.user?.userAvatar !== '')
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        alt: "avatar",
                                        src: post.value.user?.userAvatar
                                      }, null, 8, _hoisted_3))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(post.value.user?.userName), 1))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, "帖子作者：" + _toDisplayString(post.value?.user.userName), 1),
                              _createElementVNode("div", _hoisted_6, " 提交时间：" + _toDisplayString(_unref(moment)(post.value.createTime).format("YYYY-MM-DD hh:mm")), 1),
                              _createElementVNode("div", _hoisted_7, " 发布时间：" + _toDisplayString(_unref(moment)(post.value.updateTime).format("YYYY-MM-DD hh:mm")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_divider),
                      _createVNode(MdViewer, {
                        value: post.value.content || ' '
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          md: 12,
          xs: 24,
          class: "docArea"
        }, {
          default: _withCtx(() => [
            _cache[1] || (_cache[1] = _createElementVNode("h2", null, "评论", -1)),
            _createVNode(MdEditor, {
              "handle-change": onContentChange,
              value: comment.value.content || ' ',
              class: "formItem"
            }, null, 8, ["value"]),
            _createVNode(_component_a_button, {
              style: {"margin-top":"16px"},
              type: "primary",
              onClick: doCommentSubmit
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("提交 ")
              ])),
              _: 1
            }),
            _createVNode(_component_a_divider),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commentList.value, (comment, index) => {
              return (_openBlock(), _createBlock(CommentCard, {
                post: comment,
                key: index
              }, null, 8, ["post"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})